var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 10@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-717.000000, -851.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.000000, 167.000000)",
    id: "heartbeat"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,-8.51464068e-07 C10.0442295,-0.000808107342 8.82200112,0.573639233 8,1.56666667 C6.83370533,0.162612295 4.91264205,-0.360083475 3.19574444,0.259492619 C1.47884683,0.879068714 0.334263074,2.50806319 0.333333333,4.33333333 C0.333333333,8.444 7.48433333,14.3423333 7.789,14.5913333 C7.9117599,14.6917103 8.0882401,14.6917103 8.211,14.5913333 C8.51566667,14.3423333 15.6666667,8.444 15.6666667,4.33333333 C15.6639113,1.94124165 13.725425,0.00275533968 11.3333333,-8.51464068e-07 Z",
    id: "Path",
    fill: "#E86C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66666667,9.33333499 C8.55524049,9.33333499 8.45117486,9.27768991 8.38933333,9.185 L6,5.6 L4.944,7.184 C4.88238802,7.27707067 4.77828272,7.33312737 4.66666667,7.33333333 L0.333333333,7.33333333 C0.149238417,7.33333333 0,7.18409492 0,7 C0,6.81590508 0.149238417,6.66666667 0.333333333,6.66666667 L4.48833333,6.66666667 L5.72166667,4.815 C5.7868911,4.72732979 5.88972836,4.67566236 5.999,4.67566236 C6.10827164,4.67566236 6.2111089,4.72732979 6.27633333,4.815 L8.66666667,8.4 L9.72266667,6.816 C9.78427864,6.72292933 9.88838395,6.66687263 10,6.66666667 L15.6666667,6.66666667 C15.8507616,6.66666667 16,6.81590508 16,7 C16,7.18409492 15.8507616,7.33333333 15.6666667,7.33333333 L10.1783333,7.33333333 L8.945,9.185 C8.88296219,9.2779853 8.77844696,9.33368504 8.66666667,9.33333499 Z",
    id: "Path",
    fill: "#E6E6E6"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryHealth);
export default __webpack_public_path__ + "static/media/category_health.655513349eb89eb1ffef3a795618a467.svg";
export { ForwardRef as ReactComponent };